import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { StateResource } from '@schir-int-client/ngrx-helpers';
import { sameUri } from '@schir-int-client/tech';
import { VerfahrenListLinkRel } from './verfahren.linkrel';
import { VerfahrenResource } from './verfahren.model';
import { verfahrenFeatureState, VerfahrenRootState } from './verfahren.state';
import { getEmbeddedResource } from '@ngxp/rest';

export const selectFeature = createFeatureSelector<VerfahrenRootState>(verfahrenFeatureState);

export const verfahrenSelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.verfahren ?? null;
});

export const verfahrenListAsArraySelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	const verfahrenListResource = state?.verfahrenRoot?.verfahren?.resource;
	return <StateResource<VerfahrenResource[]>>{
		...(state?.verfahrenRoot?.verfahren ?? null),
		resource: verfahrenListResource
			? getEmbeddedResource(verfahrenListResource, VerfahrenListLinkRel.VERFAHREN_LIST)
			: [],
	};
});

export const verfahrenSingleSelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.verfahrenSingle ?? null;
});

export const zaehlblattSelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.zaehlblatt ?? null;
});

export const blattNummerByVerfahrenSelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.verfahrenSingle?.blattNummer ?? null;
});

export const verfahrenSearchBySelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.searchQuery ?? null;
});

export function isVerfahrenSelectedSelector(verfahren: VerfahrenResource): MemoizedSelector<object, boolean> {
	return createSelector(selectFeature, (state: VerfahrenRootState) => {
		return sameUri(state?.verfahrenRoot?.verfahrenSingle, verfahren);
	});
}

export const isAmtlicherAuszugDoneSelector = createSelector(selectFeature, (state: VerfahrenRootState) => {
	return state?.verfahrenRoot?.downloadAmtlicherAuszugDone ?? null;
});
